import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import heroImg from '../images/hero_img.jpg'

class Home extends Component {
  constructor() {
    super();

    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div className="Home">
        <div className="Home-hero" style={{backgroundImage: 'url(' + heroImg + ')'}}>
          <div>
            <h4>VINABONNEMANG DIREKT FRÅN FRANKRIKE TILL DÖRREN.</h4>
            {/*   <Link to="/">HANDLA</Link>   */}
          </div>
        </div>
        <div className="mobile-container">
          <div className="Home-content">
            <h3>Så fungerar ett vinabonnemang från Escapat</h3>
            <p>
              1. Du skapar ett abonnemang <Link to="/" target="_blank">här</Link>.<br/>
              2. Innan varje leverans skickas får du en länk som du måste veriefera via Klarna.<br/>
              3. Efter verifiering skickar vi dina varor och aktiverar din betalning.
            </p>
            <h3>Hålltider</h3>
            <p>
              <b>Beräknat leveransdatum för valda månader:</b><br/>
              Den 26:e +/- ca 7 dagar.
            </p>
            <p>
              <b>Stopptid för ändringar</b><br/>
              Den 8:e varje månad är det stopptid för ändringar.
            </p>
            <p>
              <b>Exempel</b><br/>
              Du gör ändringar på Maj månad, då kommer det fungera enligt följande 2 exempel.<br/>
              1. Görs ändringar innan eller på den 8:e maj så kommer dessa ändringar att träda i
              kraft samma månad. D.v.s. att du kommer få leveransen skickad till dig direkt.<br/>
              2. Görs ändringar efter den 8:e maj så kommer dessa ändringar att träda i kraft
               året därpå. D.v.s. att du kommer att få din första leverans på nya ändringen
               skickad till dig i Maj om ett år.
            </p>
            <h2>Hur gör man?</h2>
            <h3>Skapa ett abonnemang</h3>
            <p>
              1. Välj lådor för dem månader du vill ha leverans.<br/>
              2. Spara ditt abonnemang genom att skapa ett konto.<br/>
              3. Sätt lösenord. Klart!
            </p>
            <h3>Ändra abonnemanget</h3>
            <p>
              1. Logga in med din registrerade email.<br/>
              2. Gör ändringar i ditt abonnemang genom att klicka på + eller – på
                 vinlådor för den månad du vill ändra (ändringar måste ske senast en 1:a på aktuell månad).
            </p>
            <h3>Byt leveransadress</h3>
            <p>
              1. Du kommer att få en länk inför varje leverans där du måste godkänna ditt köp via Klarna. I den kassan fyller du i din adress.
            </p>
            <h3>Uppsägning av abonnemang</h3>
            <p>
              1. Logga in på ditt konto och klicka sedan på fliken konto.<br/>
              2. Klicka på knappen "Avsluta vinabonnemang" och följ anvisningarna.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/containers/Home.jsx